export function getPaymentMethodInArabic(method) {
  switch (method) {
    case "cash":
      return "نقداً";
    case "card":
      return "بطاقة بنكية";
    case "bank_transfer":
      return "تحويل بنكي";
    case "cheque":
      return "شيك";
    case 'cmi':
      return 'CMI';
    case 'fatourati':
      return 'فاتوراتي';
    case 'wallet':
      return 'محفظة إلكترونية';

    default:
      return "طريقة دفع غير معروفة";
  }
}

export function getPaymentMethodInFrench(method) {
  switch (method) {
    case "cash":
      return "Espèces";
    case "card":
      return "Carte bancaire";
    case "bank_transfer":
      return "Virement bancaire";
    case "cheque":
      return "Chèque";
    case 'cmi':
      return 'CMI';
    case 'fatourati':
      return 'Fatourati';
    case 'wallet':
      return 'Portefeuille';

    default:
      return "Méthode de paiement inconnue";
  }
}

export const PAYMENT_METHODS = {
  cash: "Espèces",
  card: "Carte bancaire",
  bank_transfer: "Virement bancaire",
  cheque: "Chèque",
  cmi: "CMI",
  fatourati: "Fatourati",
  wallet: "Portefeuille",
};